"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (arr) {
    return Math.min.apply(Math, _toConsumableArray(arr));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/array/arrayMin.js
// module id = 545
// module chunks = 0